import { createClient, type SupabaseClient, type SupportedStorage } from '@supabase/supabase-js';
import type { Database } from './database.types.js';

export type HiveClient = SupabaseClient<Database>;

export interface HiveClientOptions {
  url: string;
  /** The publishable (anon) key. Never the secret key. */
  publishableKey: string;
  /** Where the session lives. Defaults to localStorage in a browser. */
  storage?: SupportedStorage;
  /** Finish a PKCE sign-in from `?code=` in the URL on load. On for the browser app. */
  detectSessionInUrl?: boolean;
  /** Replaces fetch for every request, e.g. to add a header (the MCP server's on-behalf-of). */
  fetch?: typeof fetch;
}

/** Supabase client for Hive. Always PKCE, so the auth code is useless without this client's verifier. */
export function createHiveClient({
  url,
  publishableKey,
  storage,
  detectSessionInUrl = true,
  fetch: customFetch,
}: HiveClientOptions): HiveClient {
  return createClient<Database>(url, publishableKey, {
    auth: {
      flowType: 'pkce',
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl,
      storageKey: 'hive-auth',
      ...(storage ? { storage } : {}),
    },
    ...(customFetch ? { global: { fetch: customFetch } } : {}),
  });
}
